export default {
  phone: {
    title: "EMAIL",
    body: "info@3dworkshop.pt", 
    phone: "",
    description: ""
  },
  email: {
    title: "Telefone",
    body: "933650062 / 910 417 398",
    phone: "",
    description: ""
  },
  address1: {
    title: "MORADA",
    body: "Rua Poupa 231 - Fração E",
    description: "4780-528 Santo Tirso, Porto"
  }
};
